import request from "./client";

export const getInspections = async ({
  inspector,
  from: fromDate,
  to: toDate,
  device_type,
  sort_by,
  sort_dir,
  limit = 20,
  offset = 0,
}) => {
  const params = new URLSearchParams();
  if (inspector?.length) {
    inspector.forEach((i) => params.append("inspector", i));
  }
  if (fromDate) params.set("from", fromDate);
  if (toDate) params.set("to", toDate);
  if (device_type) params.set("device_type", device_type);
  if (sort_by) params.set("sort_by", sort_by);
  if (sort_dir) params.set("sort_dir", sort_dir);
  params.set("limit", String(limit));
  params.set("offset", String(offset));

  try {
    const resp = await request.get(`/v1/erp/sqlbase/inspections?${params.toString()}`);
    const body = resp.body;
    return { data: body.data, total: body.total, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: [], total: 0, error: e };
    }
    return { data: [], total: 0, error: e.response.body };
  }
};

export const getInspectionsMap = async ({
  inspector,
  from: fromDate,
  to: toDate,
  device_type,
  sort_by,
  sort_dir,
}) => {
  const params = new URLSearchParams();
  if (inspector?.length) {
    inspector.forEach((i) => params.append("inspector", i));
  }
  if (fromDate) params.set("from", fromDate);
  if (toDate) params.set("to", toDate);
  if (device_type) params.set("device_type", device_type);
  if (sort_by) params.set("sort_by", sort_by);
  if (sort_dir) params.set("sort_dir", sort_dir);

  try {
    const resp = await request.get(`/v1/erp/sqlbase/inspections/map?${params.toString()}`);
    const body = resp.body;
    return {
      data: body.data,
      total: body.total,
      located: body.located,
      unlocated: body.unlocated,
      error: null,
    };
  } catch (e) {
    if (!e.response) {
      return { data: [], total: 0, located: 0, unlocated: 0, error: e };
    }
    return { data: [], total: 0, located: 0, unlocated: 0, error: e.response.body };
  }
};

export const getTunnelStatus = async () => {
  try {
    const resp = await request.get("/v1/erp/sqlbase/tunnel");
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) return { data: null, error: e };
    return { data: null, error: e.response.body };
  }
};

export const getInspectionCard = async (slug) => {
  try {
    const resp = await request.get(`/v1/erp/sqlbase/inspections/${slug}`);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};
